// TODO: replace with chain, after https://github.com/lodash/babel-plugin-lodash/pull/176
import { get, last, meanBy, round } from 'lodash';
import { isFiniteNumber } from './checks';
export var roundAverageValue = function roundAverageValue(data, precision) {
  if (precision === void 0) {
    precision = 0;
  }

  if (data && data.length) {
    return round(meanBy(data, 'value'), precision);
  }
};
export var roundLastValue = function roundLastValue(data, precision) {
  if (precision === void 0) {
    precision = 0;
  }

  if (data && data.length) {
    return round(get(last(data), 'value'), precision);
  }
};
export var getPercent = function getPercent(value, min, max) {
  var moduleValue = value - min;
  var moduleRange = max - min;
  return moduleValue / moduleRange; // -> float: 0..1
};
export var getIndex = function getIndex(size, value, min, max) {
  var index = Math.floor(size * getPercent(value, min, max));

  if (index < 0) {
    index = 0;
  } else if (index > size - 1) {
    index = size - 1;
  }

  return index;
};
export var getItem = function getItem(array, value, min, max) {
  if (isFiniteNumber(value)) {
    return array[getIndex(array.length, value, min, max)];
  }
};